import api from "@/api/api-v2-config";

export async function getDocumentList(ReferenceID, Type = null, TypeId = null) {
    let url = `projectmanagements/project/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`;
    url = Type == null ? url : url + `&Type=${Type}`;
    url = TypeId == null ? url : url + `&TypeId=${TypeId}`;
    return await api.get(url);
}

export async function deleteDocument(id) {
    return await api.delete("projectmanagements/project/files/" + id);
}

export async function deleteDocumentS(referenceId) {
    return await api.delete("serviceorders/servicetemplatedocument/" + referenceId);
}

export async function deleteDocumentSO(referenceId) {
    return await api.delete("serviceorders/servicedocument/" + referenceId);
}

export async function uploadDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('projectmanagements/project/files/upload', formData);
}

export async function uploadMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('projectmanagements/project/files/uploads', formData);
}


export async function downloadDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("projectmanagements/project/files/download/" + id);
}

export async function shareFileDownloadAxios(id) {
    return await api.get("filesharings/download/" + id);
}

